import styled from 'styled-components'

export const SelectionAreaWrapper = styled.div`
  position: absolute;
  inset: 0;
  overflow: visible;
`

export const SelectionAreaRect = styled.div`
  position: absolute;
  border: 1px solid ${({ theme }) => theme.colors.sketch.A};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.sketch.F};
  z-index: 10000;
  will-change: width, height;
`
